module.exports = __webpack_public_path__ + "img/22.48e320e1.jpg";